import { render, staticRenderFns } from "./HistoryItemData.vue?vue&type=template&id=66bd8d2a&scoped=true&"
import script from "./HistoryItemData.vue?vue&type=script&lang=js&"
export * from "./HistoryItemData.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemData.vue?vue&type=style&index=0&id=66bd8d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd8d2a",
  null
  
)

export default component.exports